'use client'

import { Dialog, DialogContent } from '@/components/ui/shadcn/dialog'
import CreateOrganization from './CreateOrganization'
import ChooseOrganization from '../ChooseOrganization'

export default function OrganizationModal({
  open,
  setOpen,
  required,
  startPage,
  page,
  setPage,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={v => {
        if (!v && !required) setOpen(false)
      }}
    >
      <DialogContent className="max-w-lg" showCloseButton={!required}>
        {page === 'choose' && (
          <ChooseOrganization
            setOpen={arg => {
              setPage(startPage || 'choose')
              setOpen(arg)
            }}
            changePage={setPage}
          />
        )}
        {page === 'create' && (
          <CreateOrganization
            setOpen={arg => {
              setPage(startPage || 'choose')
              setOpen(arg)
            }}
            changePage={setPage}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
